import React from 'react';
import PropTypes from 'prop-types';
import { Column, List, Row } from '@pella/sash-framework';
import { CTA } from '../../../../';

const ProductsMenu = ({ data }) => {
	return (
		<div className='pal-productsMenu [&_a]:no-underline hover:[&_a]:underline focus:[&_a]:underline'>
			<Row className='divider-x-gray-15 divide-x'>
				{data.map((item, index) => (
					<Column
						key={index}
						className='!px-12'
					>
						{item.section_heading?.[0] && (
							<CTA
								data={item.section_heading[0]}
								className='block text-center text-xl'
							/>
						)}

						{item.subnav?.[0] && (
							<List
								bullets='none'
								className='my-5 columns-2'
							>
								{item.subnav.map((list, index) => (
									<li
										key={index}
										className='break-inside-avoid'
									>
										{list.heading && (
											<div
												dangerouslySetInnerHTML={{ __html: list.heading }}
												className='mb-0.5 font-semibold'
											/>
										)}

										{list.ctas?.[0] && (
											<List
												bullets='none'
												className='mb-5 mt-0'
											>
												{list.ctas.map((link, index) => (
													<li
														key={index}
														className='my-2.5 leading-snug'
													>
														<CTA data={link} />
													</li>
												))}
											</List>
										)}
									</li>
								))}
							</List>
						)}
					</Column>
				))}
			</Row>
		</div>
	);
};

ProductsMenu.propTypes = {
	data: PropTypes.array,
};

export default ProductsMenu;
